export default "__VITE_ASSET__$hR_sE0Z__"